import request from 'request';

let serverUri = 'http://ec2-35-183-185-93.ca-central-1.compute.amazonaws.com/';
//let serverUri = 'http://localhost:3001/';

export default class UserScoreShared {
    static loadUserScores(dataset, n, callback) {
        let url = serverUri + "user_score_quiz/" + dataset + "/get_random";

        var results = [];
        var allUserIds = [];
        
        let handler = (error, response, body) => {
            let user = JSON.parse(body);

            if (allUserIds.indexOf(user.item_id) == -1) {
                allUserIds.push(user.item_id);
                results.push(user);
            }

            if (results.length < n) {
                request(url, handler);
            } else {
                // Done!
                callback(results);
            }
        };

        request(url, handler);
    }

    static submitResponses(dataset, name, responses, points, callback) {
        let url = serverUri + "user_score_quiz/submit_responses";

        request.post(url, { form: { responses: JSON.stringify(responses), points: points, name: name }}, (error, response, body) => {
            body = JSON.parse(body);
            callback(body);
        });
    }

    static loadLeaderboard(browserId, callback) {
        let url = serverUri + "user_score_quiz/leaderboard?browser_id=" + browserId;

        request(url, (error, response, body) => {
            body = JSON.parse(body);
            callback(body);
        });
    }
}


// WEBPACK FOOTER //
// ./src/UserScoreShared.js